<div>
  <mat-selection-list>  
    <mat-list-option [value]="question.QuestionId" class="questionItem" *ngFor="let question of questions">
     {{question.QuestionText}}
  </mat-list-option>   
 </mat-selection-list>   

</div>

